import { useEffect, useRef } from 'react';
const castThroughSchema = (schema, values) => {
    if (!schema)
        return values;
    try {
        return schema.cast(values, { assert: false });
    }
    catch {
        return values;
    }
};
export const useFormAutoSave = (subscribe, onSync, schema) => {
    const schemaRef = useRef(schema);
    schemaRef.current = schema;
    useEffect(() => {
        const unsubscribe = subscribe({
            formState: {
                values: true,
            },
            callback: ({ values }) => {
                if (values) {
                    onSync(castThroughSchema(schemaRef.current, values));
                }
            },
        });
        return unsubscribe;
    }, [subscribe, onSync]);
};
